import React from "react";
import "./style.css";

export const Faq = () => {
    return (
        <div className={'privacy-main-content'}>
            <div>Last updated: 22 October 2024</div>
            <h2><strong>FAQ </strong></h2>

            <h3>How do I sign up?</h3>
            <p>
                Getting started is easy! Visit Calo Sign-Up and answer a few quick questions about your eating habits, weight goals, and overall fitness level. We'll also ask for your email—please ensure it's entered correctly. Once we have your details, we'll generate a personalized weight management plan and provide you with the app download link so you can start immediately.
            </p>
            <h3>How will I receive my customized weight management plan?</h3>
            <p>
                After completing your sign-up and payment, you'll receive a unique download link that directs you to the App Store or Google Play. Install the Calo app and log in using your registered email to access your custom plan. If you encounter any issues with downloading or accessing the app, please contact our support team at website@caloapp.ai.
            </p>
            <h3>When will I receive my customized weight management plan?</h3>
            <p>
                Your personalized weight management plan will be available immediately after payment. Simply download the app using the unique link provided, log in, and your plan will be ready for you.
            </p>
            <h3>How do I log in?</h3>
            <p>
                Follow these steps to access your Calo account: <br/>
                Download the Calo app from the App Store or Google Play. <br/>
                Open the app and select "Log in."<br/>
                Enter your registered email address and password.<br/>
                You're all set! Enjoy your workouts.<br/>

                If you registered on our website, use the same email and password to log in. If you have trouble logging in, contact website@caloapp.ai for assistance.
            </p>
            <h3>How will I be billed?</h3>
            <p>
                Calo offers auto-renewing subscription plans. Depending on the plan you choose, your subscription will automatically renew at the end of each billing period.
            </p>
            <h3>How do I cancel my subscription?</h3>
            <p>
                Your subscription renews automatically unless you cancel it. Please note that deleting the app does not cancel your subscription.<br/>
                To cancel your subscription, follow the steps below based on where you purchased it:<br/>
                If you purchased a subscription or enabled trial on our websites:<br/>
                To cancel, email website@caloapp.ai at least 24 hours before your next billing cycle.<br/><br/>

                If you purchased a subscription or enabled trial on the App Store:<br/>
                Go to your Apple ID account settings and turn off auto-renewal.<br/>
                Cancel at least 24 hours before the renewal date to avoid being charged.<br/>
                For more details, visit <a href="https://support.apple.com/en-ca/HT202039">Apple support page</a><br/><br/>

                If you purchased a subscription or enabled trial on Google Play:<br/>
                Open Google Play Store, navigate to your account settings, and manage your subscriptions.<br/>
                Cancel at least 24 hours before the renewal date to avoid being charged.<br/>
                Learn more on <a href="https://support.google.com/googleplay/answer/7018481?co=GENIE.Platform%3DAndroid&hl=en">Google support page</a> <br/>
            </p>
            <h3>How can I turn off auto-renewal?</h3>
            <p>
                If you find Calo dosen't fit you needs, you can cancel your calo subscription's auto-renewal or get your money back by sending a payment email to website@caloapp.ai.
            </p>
            <h3>Can I get a refund?</h3>
            <p>
                If Calo doesn't meet your needs, you may be eligible for a refund. Please email website@caloapp.ai using the same email you registered with on our website for assistance with cancellations and refunds.
            </p>
        </div>
    );
};
